import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { styless } from './styles';
import './style.scss';

const LogoutConfirm = ({ Logout }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const escFunction = (event) => {
    if (event.keyCode === 27) {
      setShowModal(false);
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const logout = () => {
    Logout();
  };

  const modal = showModal ? (
    <div className='modal'>
      <div className='modal-overlay'></div>

      <div className='modal-body'>

        <div className='forgot_form'>
          <h5>{'Are you sure you want to logout?'}</h5>
          <div className='modal-header'>
              <span className='logout-confirm-btns'>
                <button onClick={closeModal} className='cancel'>
                  Cancel
                </button>
                <button onClick={logout} className='logout-btn'>
                  Log Out
                </button>
              </span>
            <View style={styless.cancelBtnWrapper}>
              <TouchableOpacity
                style={styless.cancelButton}
                onPress={closeModal}
              >
                <i>
                  <img
                    src={require('../../../Assets/Images/Icons/close_icon.png')}
                    alt='close'
                  />
                </i>
              </TouchableOpacity>
            </View>
          </div>
        </div>

      </div>
    </div>
  ) : null;
  return (
    <>
      <a onClick={openModal} className='logout'>
        Log out
      </a>

      {modal}
    </>
  );
};
export default LogoutConfirm;
